import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ACADEMIC_RECOGNITION_TYPE } from "../../../../config/registers/common";
import { AcademicRecognitionType } from "../../../../types/academicRecognition";

type AcademicRecognitionTabState = {
  activeTab: AcademicRecognitionType;
};

const initialState: AcademicRecognitionTabState = { activeTab: ACADEMIC_RECOGNITION_TYPE.NACID };

const academicRecognitionDataSlice = createSlice({
  name: "academicRecognitionData",
  initialState: initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<AcademicRecognitionTabState>) => {
      const { activeTab } = action.payload;
      state.activeTab = activeTab;
    },
  },
});

export const { setActiveTab } = academicRecognitionDataSlice.actions;

export default academicRecognitionDataSlice.reducer;
